class Colorsheme {

    constructor() {
        setTimeout(() => {
            let b = new Image();
            b.src = ((<HTMLImageElement>document.getElementById('sourcereplacer')!)).src;
            b.onload = () => {

                let bcolor = this.getAverageRGB(b);
                let butleft: any = document.querySelector('[data-dir="left"] .pure-button.normalklick')!;
                if (butleft)
                    butleft.style.background = 'rgb(' + bcolor + ')';
                let butright: any = document.querySelector('[data-dir="right"] .pure-button.normalklick')!;
                if (butright)
                    butright.style.background = 'rgb(' + bcolor + ')';
                let all: any = document.querySelector('.pure-button.pure-button-small.mb35')!;
                if (all)
                    all.style.background = 'rgb(' + bcolor + ')';
                let bcorderolor: any = document.querySelectorAll('.articel_description h2')!;
                for (let e = 0; e < bcorderolor.length; e++) {
                    bcorderolor[e].style.borderBottomColor = 'rgb(' + bcolor + ')';
                }
            }
        }, 360);
    }


    getAverageRGB(imgEl: any) {
        var blockSize = 5, // only visit every 5 pixels
            defaultRGB = {r: 0, g: 0, b: 0}, // for non-supporting envs
            canvas = document.createElement('canvas'),
            context = canvas.getContext && canvas.getContext('2d'),
            data, width, height,
            i = -4,
            length,
            rgb = {r: 0, g: 0, b: 0},
            count = 0;

        if (!context) {
            return defaultRGB;
        }

        height = canvas.height = imgEl.naturalHeight || imgEl.offsetHeight || imgEl.height;
        width = canvas.width = imgEl.naturalWidth || imgEl.offsetWidth || imgEl.width;

        context.drawImage(imgEl, 0, 0);

        try {
            data = context.getImageData(0, 0, width, height);
        } catch (e) {
            /* security error, img on diff domain */
            return defaultRGB;
        }
        length = data.data.length;
        while ((i += blockSize * 4) < length) {
            ++count;
            rgb.r += data.data[i];
            rgb.g += data.data[i + 1];
            rgb.b += data.data[i + 2];
        }
        let rgbout = ~~(rgb.r / count).toString() + ',';
        rgbout += ~~(rgb.g / count).toString() + ',';
        rgbout += ~~(rgb.b / count).toString();

        return rgbout;

    }


}

new Colorsheme();
